import React, { Component, useEffect, useState } from 'react';
import TransactionsView from './TransactionsView';
import crmservices from '../../wsclient/crmservices';
import { getCurrency } from '../../utils/common';

function Transactions(props) {
            const [showLoading, onShowLoading] = useState(false);
            const [transactions, setTransactions] = useState(null);
            const currency = getCurrency();
            const [hasMore, setHasMore] = useState(true);
            const [showLoadMore, onShowLoadMore] = useState(false);
            const [paging, setPaging] = useState(null);
            const [transactionDetail, setTransactionDetail] = useState(null);
            const [showDetail, onShowDetail] = useState(false);
    useEffect(()=>{
        onLoadRewardsTransactions(false)
    },[])
    
    const onLoadRewardsTransactions = async (isRefresh) =>{
        onShowLoading(true);
        try {
            let result = await crmservices.contacts.getContactPurchases();
           //console.log('onLoadRewardsTransactions transactions result=',result)
            if (result.code == 'OK') {
                setTransactions(result.data.content);
                setPaging(result.data.paging);

                
                if ( result.data.paging && result.data.paging.size < 10){
                    setHasMore(false);
                }
            }
        } catch (error) {
            console.log("load rewards transactions error:", error);
        }
        onShowLoading(false);
    }
    const handleLoadMore = async() =>{
       
        let page = paging.page+1
        setPaging(prevState =>({
            ...prevState,
            page: page
        }));
        onShowLoadMore(true);
        try {
            let result = await crmservices.contacts.getContactPurchases({page: page});
            //console.log('handleLoadMore transactions result=',result)
            if (result.code == 'OK') {
                setTransactions([...transactions,...result.data.content])
                
                if ( result.data.paging && result.data.paging.size < 10){
                    setHasMore(false);
                }
            }
        } catch (error) {
            console.log("load rewards transactions error:", error);
        }
    }
    const onClickDetail = (item) =>{
        if (transactionDetail&&transactionDetail.id&&item.id===transactionDetail.id){
            onShowDetail(!showDetail)
        }
        else{
            setTransactionDetail(item);
            onShowDetail(true);
        }
        
        
    }
    return (
        <div>
            <TransactionsView 
                open={props.open} 
                handleDrawerOtherToggle= {props.handleDrawerOtherToggle}
                transactions = {transactions}
                currency = {currency}
                handleLoadMore = {handleLoadMore}
                showLoadMore = {showLoadMore}
                hasMore= {hasMore}
                showLoading = {showLoading}
                onClickDetail = {onClickDetail}
                transactionDetail = {transactionDetail}
                showDetail={showDetail}/>
        </div>
    );
}

export default Transactions;